/* ============================
   Offerte pagina (multi product)
   - producten uit localStorage (SSOffer)
   - formulier velden in sessionStorage
   ============================ */

(function () {
  'use strict';

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatEUR(cents) {
    var n = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch (e) {
      return '€ ' + n.toFixed(2).replace('.', ',');
    }
  }

  function euroToCents(v) {
    // accepteert "€ 1.234,56" en varianten
    var s = String(v || '').trim();
    if (!s) return 0;
    s = s.replace(/[^0-9,.-]/g, '');
    // "1.234,56" -> "1234.56"
    if (s.includes(',') && s.includes('.')) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (s.includes(',')) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function stripSku(sku) {
    var s = String(sku || '');
    var i = s.indexOf('_');
    return i >= 0 ? s.slice(0, i) : s;
  }

  function guessColorLabel(raw, fallbackTitle) {
    var rawStr = String(raw || '').trim();
    var titleStr = String(fallbackTitle || '').trim();

    if (rawStr === 'Default Title') rawStr = '';

    var usingFallback = !rawStr;
    var s = rawStr || titleStr;
    if (!s) return '';

    // Als dit (nog) een volledige titel is, pak het laatste segment.
    // We gebruiken dit o.a. wanneer "Product kleur" per ongeluk de volledige titel bevat.
    var extracted = '';
    if (s.indexOf(' - ') >= 0) extracted = s.split(' - ').pop();
    else if (s.indexOf('|') >= 0) extracted = s.split('|').pop();

    extracted = String(extracted || '').trim();
    if (extracted) return extracted;

    // Soms wordt per ongeluk de volledige titel als kleur opgeslagen.
    if (rawStr && titleStr && rawStr === titleStr) return '-';

    // Zonder expliciete kleur: liever '-' dan de volledige producttitel.
    if (usingFallback) return '-';

    return s;
  }


  function splitBr(html) {
    return String(html || '')
      .split(/<br\s*\/?\s*>/i)
      .map(function (x) {
        return String(x || '').replace(/<[^>]+>/g, '').trim();
      })
      .filter(Boolean);
  }

  function cleanLine(s) {
    return String(s || '')
      .replace(/&nbsp;/g, ' ')
      .replace(/\u00a0/g, ' ')
      .replace(/^•\s*/, '')
      .replace(/^\(per stuk\)\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
function formatSizesDisplayHtml(htmlOrLines) {
  var lines = Array.isArray(htmlOrLines) ? htmlOrLines : splitBr(htmlOrLines);
  lines = lines.map(cleanLine).filter(Boolean);
  if (!lines.length) return '';

  // Als er maar 1 maatregel is, toon alleen de maat (zonder "25 stuks").
  if (lines.length === 1) {
    var one = String(lines[0] || '').trim();

    // Voorbeeld: "25 stuks XL" / "1 stuk L" -> "XL" / "L"
    var m = one.match(/^\s*\d+\s*(?:stuks?|stuk)\s+(.+)$/i);
    if (m && m[1]) one = String(m[1]).trim();

    return escapeHtml(one);
  }

  return (
    '<br>' +
    lines
      .map(function (l) {
        return '• ' + escapeHtml(l);
      })
      .join('<br>')
  );
}
function formatPpiDisplayHtml(htmlOrLines) {
  var lines = Array.isArray(htmlOrLines) ? htmlOrLines : splitBr(htmlOrLines);
  lines = lines.map(cleanLine).filter(Boolean);
  if (!lines.length) return '';

  // Als er maar 1 maat/variant is, is "S: € 2,15" dubbelop.
  // Toon dan alleen de prijs (zonder de "S:").
  if (lines.length === 1) {
    var one = String(lines[0] || '').trim();
    if (one.includes(':')) one = one.replace(/^[^:]+:\s*/, '');
    return escapeHtml(one);
  }

  return (
    '<br>' +
    lines
      .map(function (l) {
        return '• (per stuk) ' + escapeHtml(l);
      })
      .join('<br>')
  );
}


  function sizesToLines(item) {
    if (Array.isArray(item?.sizes) && item.sizes.length) {
      return item.sizes.map(function (s) {
        return (s.qty || 0) + ' stuks ' + (s.label || '');
      }).filter(Boolean);
    }
    if (item?.sizesHTML) return splitBr(item.sizesHTML);
    return [];
  }

  function parseSizesFromItem(item) {
    // Normaliseer maatregels naar: [{ qty, label }]
    // Bronnen: item.sizes (array) óf item.sizesHTML (br-separated string)
    var out = [];
    var lines = sizesToLines(item).map(cleanLine).filter(Boolean);

    lines.forEach(function (txt) {
      // Als het alleen een aantal is (bijv. "26 stuks"), dan is er geen maat.
      if (/^[0-9]+\s*stuks?$/i.test(String(txt || '').trim())) return;

      // verwacht: "10 stuks S" (qty + label)
      var m = String(txt || '').match(/^([0-9]+)\s*stuks?\s*(.+)$/i);
      if (m) {
        var qty = parseInt(m[1], 10);
        var label = String(m[2] || '').trim();
        if (/^default title$/i.test(label)) return;
        if (label) out.push({ qty: qty, label: label });
        return;
      }

      // fallback: alleen label
      var fallback = String(txt || '').trim();
      if (!fallback) return;
      if (/^default title$/i.test(fallback)) return;
      out.push({ qty: Number(item && item.qty) || 0, label: fallback });
    });

    // dedupe op label (veiligheidsnet)
    var seen = {};
    out = out.filter(function (x) {
      var k = String((x && x.label) || '').trim();
      if (!k) return false;
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    });

    return out;
  }

  function ppiToLines(item) {
    if (Array.isArray(item?.ppi) && item.ppi.length) {
      return item.ppi.map(function (p) {
        return (p.label ? p.label + ': ' : '') + formatEUR(p.exCents || 0);
      }).filter(Boolean);
    }
    if (item?.ppiHTML) return splitBr(item.ppiHTML);
    return [];
  }

  function getItemTotals(item) {
    var ex = 0;
    if (Number.isFinite(item?.totalExCents)) ex = Number(item.totalExCents);
    else if (item?.totalEx) ex = euroToCents(item.totalEx);
    var inc = 0;
    if (Number.isFinite(item?.totalIncCents)) inc = Number(item.totalIncCents);
    else if (item?.totalInc) inc = euroToCents(item.totalInc);
    else inc = Math.round(ex * 1.21);

    return { exCents: ex, incCents: inc };
  }

  function byId(id) {
    return document.getElementById(id);
  }

  function showOfferteMinModal(message) {
    var modal = byId('ssOfferteMinModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'ssOfferteMinModal';
      modal.className = 'ss-offerte-minmodal';
      modal.innerHTML =
        '<div class="ss-offerte-minmodal__backdrop" data-ss-offerte-minmodal-close></div>' +
        '<div class="ss-offerte-minmodal__dialog" role="alertdialog" aria-modal="true">' +
        '  <div class="ss-offerte-minmodal__body">' +
        '    <p class="ss-offerte-minmodal__text"></p>' +
        '    <button type="button" class="btn accent ss-offerte-minmodal__btn" data-ss-offerte-minmodal-close>OK</button>' +
        '  </div>' +
        '</div>';
      document.body.appendChild(modal);

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-ss-offerte-minmodal-close]')) {
          modal.setAttribute('hidden', 'hidden');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
          modal.setAttribute('hidden', 'hidden');
        }
      });
    }

    var textEl = modal.querySelector('.ss-offerte-minmodal__text');
    if (textEl) textEl.textContent = String(message || '').trim();
    modal.removeAttribute('hidden');
  }

  function toCents(v) {
    if (v == null) return 0;
    var n = Number(v);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function int(v) {
    var n = parseInt(String(v || '0'), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function ssPickPct(qty, tiers) {
    qty = Number(qty || 0);
    if (!Number.isFinite(qty)) qty = 0;
    tiers = Array.isArray(tiers) ? tiers : [];
    var best = 0;
    tiers.forEach(function (row) {
      if (!row) return;
      var min = Number(row.min || row.min_qty || row.quantity || row.qty || 0);
      if (!Number.isFinite(min)) min = 0;
      var pct = Number(row.pct || row.percent || row.discount || 0);
      if (!Number.isFinite(pct)) pct = 0;
      if (qty >= min && pct > best) best = pct;
    });
    return best;
  }

  function ssApplyPctToCents(baseCents, pct) {
    baseCents = Math.max(0, Math.round(Number(baseCents || 0)));
    pct = Number(pct) || 0;
    if (!Number.isFinite(pct)) pct = 0;
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;

    // pct = 15 => -15%
    // Zelfde afronding als ss-pdp-configure.js (basis points, half-up)
    var bp = Math.round(pct * 100); // 1% = 100 bp
    var factorBp = 10000 - bp;

    if (typeof BigInt !== 'undefined') {
      var num = BigInt(baseCents) * BigInt(factorBp) + BigInt(5000);
      return Number(num / BigInt(10000));
    }

    return Math.round(baseCents * (1 - pct / 100));
  }

  function sizesArrayFromItem(item) {
    if (Array.isArray(item?.sizes) && item.sizes.length) {
      return item.sizes
        .map(function (s) {
          return {
            label: String(s?.label || '').trim(),
            qty: Number(s?.qty || 0),
          };
        })
        .filter(function (s) {
          return s.qty > 0;
        });
    }

    var out = [];
    var lines = item?.sizesHTML ? splitBr(item.sizesHTML) : [];
    lines.map(cleanLine).forEach(function (line) {
      var m = String(line || '').match(/^(\d+)\s*stuks(?:\s+(.*))?$/i);
      if (!m) return;
      var qty = Number(m[1] || 0);
      if (!qty) return;
      var label = String(m[2] || '').trim();
      out.push({ label: label, qty: qty });
    });

    // fallback
    if (!out.length && item?.qty) {
      out.push({ label: '', qty: Number(item.qty || 0) });
    }
    return out;
  }

  function sizesArrayToHTML(sizes) {
    sizes = Array.isArray(sizes) ? sizes : [];
    return sizes
      .map(function (s) {
        var qty = Number(s?.qty || 0);
        if (!qty) return '';
        var label = String(s?.label || '').trim();
        return label ? qty + ' stuks ' + label : qty + ' stuks';
      })
      .filter(Boolean)
      .join('<br>');
  }

  function ppiArrayToHTML(ppi) {
    ppi = Array.isArray(ppi) ? ppi : [];
    return ppi
      .map(function (p) {
        var label = String(p?.label || '').trim();
        var ex = Number(p?.exCents || 0);
        return label ? label + ': ' + formatEUR(ex) : formatEUR(ex);
      })
      .filter(Boolean)
      .join('<br>');
  }

  function sumSizesQty(sizes) {
    sizes = Array.isArray(sizes) ? sizes : [];
    return sizes.reduce(function (sum, s) {
      return sum + Number(s?.qty || 0);
    }, 0);
  }

  function offerMinKey(it) {
    if (!it || typeof it !== 'object') return '';
    var fam = it.minFamilyKey != null ? String(it.minFamilyKey).trim() : '';
    if (fam) return 'fam:' + fam;
    var pid = '';
    if (it.pid != null && String(it.pid).trim() !== '') pid = String(it.pid).trim();
    else if (it.productId != null && String(it.productId).trim() !== '') pid = String(it.productId).trim();
    var handle = String(it.handle || '').trim();
    if (!pid && handle) return 'handle:' + handle;
    if (pid) return 'pid:' + pid;
    return 'id:' + String(it.id || '').trim();
  }

  function offerTierKey(it, printOverride) {
    if (!it || typeof it !== 'object') return '';
    var handle = String(it.handle || '').trim();
    var fam =
      it.minFamilyKey != null && String(it.minFamilyKey).trim() !== ''
        ? String(it.minFamilyKey).trim()
        : '';
    var pid = '';
    if (it.pid != null && String(it.pid).trim() !== '') pid = String(it.pid).trim();
    else if (it.productId != null && String(it.productId).trim() !== '') pid = String(it.productId).trim();
    // Staffels: eerst familie-key (variant_collection of product.id),
    // dan productId, en pas als laatste de concrete handle (kleur-variant).
    var base = fam || pid || handle;
    var print = cleanPrintLabel(printOverride != null ? printOverride : it.print || 'Onbedrukt')
      .trim()
      .toLowerCase();
    return base ? base + '::' + print : print;
  }

  function cleanPrintLabel(label) {
    return String(label || '')
      .trim()
      .replace(/^bedrukkingskosten\s*[-–—:]\s*/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeTechniqueLabel(label) {
    return cleanPrintLabel(label)
      .replace(/\s*[-–—]\s*/g, ' - ')
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  // Zoek druktechniek-ID op basis van label (zelfde logica gebruiken
  // voor repriceOfferGroup én de Aanpassen-modal).
  function getTechniqueIdForLabel(label, techniques) {
    var l = normalizeTechniqueLabel(label);
    if (!l || l === 'onbedrukt') return '';
    techniques = Array.isArray(techniques) ? techniques : [];

    var t = techniques.find(function (x) {
      return normalizeTechniqueLabel(x && x.title) === l;
    });
    if (t) return String(t.id);

    var loose = techniques.filter(function (x) {
      var title = normalizeTechniqueLabel(x && x.title);
      if (!title) return false;
      return l.indexOf(title) !== -1 || title.indexOf(l) !== -1;
    });

    return loose.length === 1 ? String(loose[0].id) : '';
  }

  function sizesFromItem(it) {
    if (!it || typeof it !== 'object') return [];
    var parsed = parseSizesFromItem(it);
    if (parsed && parsed.length) {
      return parsed
        .map(function (s) {
          var q = Number(s && s.qty || 0);
          var lbl = String(s && s.label || '').trim();
          if (!q) return null;
          return { label: lbl, qty: q };
        })
        .filter(Boolean);
    }

    var q2 = Number(it.qty || 0);
    var lbl2 = String(it.variantTitle || '').trim();
    if (!q2) return [];
    return [{ label: lbl2, qty: q2 }];
  }

  function repriceOfferGroup(baseItem, ctx) {
    if (!window.SSOffer || typeof window.SSOffer.load !== 'function') return;
    if (!baseItem || typeof baseItem !== 'object') return;

    try {
      var product = ctx && ctx.product;
      var tierCfg = ctx && ctx.tierCfg;
      var techniques = Array.isArray(ctx && ctx.techniques) ? ctx.techniques : [];
      var minFamilyKey = ctx && ctx.minFamilyKey;
      if (!product || !tierCfg) return;

      var items = window.SSOffer.load() || [];
      var baseId = String(baseItem.id || '');

      // Merge het aangepaste item in de lijst
      items = items.map(function (it) {
        if (!it || String(it.id || '') !== baseId) return it;
        var next = Object.assign({}, it, baseItem);
        if (minFamilyKey != null && minFamilyKey !== '') next.minFamilyKey = minFamilyKey;
        return next;
      });

      // Bepaal familie-key (zelfde logica als offerMinKey, maar met expliciete minFamilyKey)
      var famCandidate = Object.assign({}, baseItem);
      if (minFamilyKey != null && minFamilyKey !== '') famCandidate.minFamilyKey = minFamilyKey;
      var familyKey = offerMinKey(famCandidate);
      if (!familyKey) familyKey = offerMinKey(baseItem);
      if (!familyKey) return;

      // Groepeer alle regels binnen deze familie per staffel-key (familie + druktechniek)
      var groups = Object.create(null); // staffelKey -> { qty, techId }
      items.forEach(function (it) {
        if (!it) return;
        if (offerMinKey(it) !== familyKey) return;

        var key = offerTierKey(it);
        if (!key) return;

        if (!groups[key]) {
          var label = cleanPrintLabel(it.print || 'Onbedrukt');
          var techIdForGroup = getTechniqueIdForLabel(label, techniques);
          groups[key] = {
            qty: 0,
            techId: techIdForGroup || '',
          };
        }

        groups[key].qty += Number(it.qty || 0);
      });

      var updated = items.map(function (it) {
        if (!it) return it;
        if (offerMinKey(it) !== familyKey) return it;

        var key = offerTierKey(it);
        var group = key && groups[key];
        if (!group || !Number.isFinite(group.qty) || group.qty <= 0) return it;

        var sizes = sizesFromItem(it);
        var pricing = computeOfferPricing({
          product: product,
          tierCfg: tierCfg,
          techniqueId: group.techId,
          sizes: sizes,
          tierQty: group.qty,
        });

        var next = Object.assign({}, it, {
          qty: pricing.qtyTotal,
          sizes: sizes,
          sizesHTML: sizesArrayToHTML(sizes),
          ppi: pricing.ppi,
          ppiHTML: ppiArrayToHTML(pricing.ppi),
          totalExCents: pricing.totalExCents,
          totalIncCents: pricing.totalIncCents,
          totalEx: formatEUR(pricing.totalExCents),
          totalInc: formatEUR(pricing.totalIncCents),
        });

        if (minFamilyKey != null && minFamilyKey !== '') next.minFamilyKey = minFamilyKey;
        return next;
      });

      window.SSOffer.save(updated);
    } catch (err) {
      console.error('[ss-offerte] repriceOfferGroup failed; falling back to simple upsert', err);
      try {
        if (window.SSOffer && typeof window.SSOffer.upsert === 'function') {
          window.SSOffer.upsert(baseItem);
        }
      } catch (e2) {}
    }
  }

  function computeOfferPricing(opts) {
    opts = opts || {};
    var product = opts.product || null;
    var tierCfg = opts.tierCfg || null;
    var techniqueId = String(opts.techniqueId || '').trim();
    var sizes = Array.isArray(opts.sizes) ? opts.sizes : [];

    var qtyTotal = sumSizesQty(sizes);
    var tierQty = opts && opts.tierQty != null ? Number(opts.tierQty) : qtyTotal;
    if (!Number.isFinite(tierQty) || tierQty < 0) tierQty = qtyTotal;
    // taxRate in ss-b2b_tiers-product-pdp is a PERCENT (bv. 21), niet 0.21
    var taxRate = tierCfg && tierCfg.taxRate != null ? Number(tierCfg.taxRate) : 21;
    if (!Number.isFinite(taxRate)) taxRate = 21;

    // Zelfde staffellogica als ss-b2b-tiers-pdp.js:
    // - Als er hoofdproduct-tiers zijn (tierCfg.tiers), dan alleen daar korting op
    //   toepassen en techniek-prijs ongewijzigd laten.
    // - Als er géén hoofd-tiers zijn maar wel techniek-tiers, dan korting op techniek.

    var hasMainTiers =
      tierCfg && Array.isArray(tierCfg.tiers) && tierCfg.tiers.length > 0;
    var pctMain = hasMainTiers
      ? ssPickPct(tierQty, (tierCfg && tierCfg.tiers) || [])
      : 0;

    // Techniek-config kan ofwel een getal zijn (legacy) of een object { base, tiers }.
    var techCfgMap = tierCfg && tierCfg.tech ? tierCfg.tech : null;
    var rawTechCfg = techCfgMap && techniqueId ? techCfgMap[techniqueId] : null;
    var techBaseCents = 0;
    var techTiers = null;
    if (rawTechCfg != null) {
      if (typeof rawTechCfg === 'number') {
        techBaseCents = toCents(rawTechCfg);
      } else if (rawTechCfg && rawTechCfg.base != null) {
        techBaseCents = toCents(rawTechCfg.base);
        if (Array.isArray(rawTechCfg.tiers)) techTiers = rawTechCfg.tiers;
      }
    }

    var pctTech =
      !hasMainTiers && techBaseCents ? ssPickPct(tierQty, techTiers || []) : 0;
    var unitTechEx = techBaseCents
      ? ssApplyPctToCents(techBaseCents, pctTech)
      : 0;

    var variants = Array.isArray(product?.variants) ? product.variants : [];
    var mainPrices = tierCfg && tierCfg.mainPrices ? tierCfg.mainPrices : {};

    function pickVariantByLabel(label) {
      label = String(label || '').trim();
      if (!variants.length) return null;
      if (!label) return variants[0];
      var v = variants.find(function (x) {
        return String(x?.title || '').trim() === label;
      });
      if (v) return v;
      v = variants.find(function (x) {
        return Array.isArray(x?.options) && String(x.options[0] || '').trim() === label;
      });
      return v || variants[0];
    }

    var ppi = [];
    var totalExCents = 0;

    sizes.forEach(function (s) {
      var qty = Number(s?.qty || 0);
      if (!qty) return;
      var label = String(s?.label || '').trim();
      var v = pickVariantByLabel(label);
      var vid = v ? String(v.id) : '';
      var baseMain =
        vid && mainPrices && mainPrices[vid] != null
          ? mainPrices[vid]
          : (tierCfg && tierCfg.main && tierCfg.main.base != null
              ? tierCfg.main.base
              : 0);

      var baseMainCents = toCents(baseMain);
      var unitMainEx = hasMainTiers
        ? ssApplyPctToCents(baseMainCents, pctMain)
        : baseMainCents;
      var unitEx = unitMainEx + unitTechEx;
      ppi.push({ label: label, exCents: unitEx });
      totalExCents += unitEx * qty;
    });

    if (!ppi.length && qtyTotal > 0) {
      var baseMain2 =
        tierCfg && tierCfg.main && tierCfg.main.base != null
          ? tierCfg.main.base
          : 0;
      var baseMain2Cents = toCents(baseMain2);
      var unitMain2 = hasMainTiers
        ? ssApplyPctToCents(baseMain2Cents, pctMain)
        : baseMain2Cents;
      var unitEx2 = unitMain2 + unitTechEx;
      ppi.push({ label: '', exCents: unitEx2 });
      totalExCents = unitEx2 * qtyTotal;
    }

    // Zelfde afronding als ss-pdp-configure.js (half-up)
    var totalIncCents = Math.floor((totalExCents * (100 + taxRate) + 50) / 100);
    return {
      qtyTotal: qtyTotal,
      taxRate: taxRate,
      ppi: ppi,
      totalExCents: totalExCents,
      totalIncCents: totalIncCents,
    };
  }

  function parseQtyOptions(val) {
    if (Array.isArray(val)) {
      return val
        .map(function (x) { return Number(x); })
        .filter(function (x) { return Number.isFinite(x) && x > 0; });
    }
    if (val == null) return [];
    if (typeof val === 'number') return Number.isFinite(val) && val > 0 ? [val] : [];
    var str = String(val || '').trim();
    if (!str) return [];
    // Probeer JSON eerst
    try {
      var parsed = JSON.parse(str);
      if (Array.isArray(parsed)) return parseQtyOptions(parsed);
    } catch (e) {}
    // Fallback: "10,25,50"
    return str
      .split(',')
      .map(function (s) { return Number(String(s).trim()); })
      .filter(function (x) { return Number.isFinite(x) && x > 0; });
  }

  function normalizeFromLegacySession() {
    // Oude flow: 1 product in sessionStorage. Als localStorage leeg is,
    // zetten we ‘m om naar het nieuwe offertemandje.
    if (!window.SSOffer || typeof window.SSOffer.load !== 'function') return;
    var current = window.SSOffer.load();
    if (current && current.length) return;

    var raw = '';
    try {
      raw = sessionStorage.getItem('ss_quote_payload') || '';
    } catch (e) {}
    if (!raw) return;

    try {
      var p = JSON.parse(raw);
      if (!p || typeof p !== 'object') return;
      p.id = p.id || 'legacy_' + Date.now();
      window.SSOffer.add(p);
      try {
        sessionStorage.removeItem('ss_quote_payload');
      } catch (e2) {}
    } catch (e3) {
      console.warn('[ss-offerte] legacy payload parse mislukt', e3);
    }
  }

  function buildItemRowsHtml(item, opts) {
    var o = opts || {};
    var config = window.SSOffer?.getConfigurator?.(item);
    var configProperties = window.SSOffer?.configuratorProperties?.(item);

    function row(label, valueHtml) {
      return (
        '<div class="qs-row">' +
        '<strong>' +
        escapeHtml(label) +
        '</strong>' +
        '<span>' +
        (valueHtml || '') +
        '</span>' +
        '</div>'
      );
    }

    function productTitleBlock() {
      var title = String(item?.title || '').trim() || '—';
      var url = item?.url || (item?.handle ? '/products/' + item.handle : '');

      var titleHtml = url
        ? '<a class="ss-offerte-product-link" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>'
        : escapeHtml(title);

      return '<div class="ss-offerte-item__product-title">' + titleHtml + '</div>';
    }

    function topRows() {
      var sku = stripSku(item?.sku || '');
      var title = String(item?.title || '').trim() || '—';
      var color = guessColorLabel(item?.color, title) || '—';
      var skuDisp = sku || '—';

      var html = '';
      html += productTitleBlock();
      if (!config) html += row('Product kleur:', escapeHtml(color));
      html += row('Artikelnummer:', escapeHtml(skuDisp));
      return html;
    }

    function detailRows() {
      var qty = item?.qty != null ? String(item.qty) : '';
      var sizesLines = sizesToLines(item);
      var parsedSizes = parseSizesFromItem(item);
      var sizeLabels = (parsedSizes || [])
        .map(function (s) {
          return String((s && s.label) || '').trim();
        })
        .filter(Boolean);
      var ppiLines = ppiToLines(item);
      var totalExTxt =
        item?.totalEx || (Number.isFinite(item?.totalExCents) ? formatEUR(item.totalExCents) : '');
      var totalIncTxt =
        item?.totalInc || (Number.isFinite(item?.totalIncCents) ? formatEUR(item.totalIncCents) : '');

      var html = '';
      if (qty) html += row('Aantal:', escapeHtml(qty + ' stuks'));
      if (config && configProperties) {
        html += '<div class="ss-offerte-configuration" data-ss-configurator-colors="' + escapeHtml(JSON.stringify(config.colorSwatches || {})) + '">';
        Object.entries(configProperties).forEach(function (entry) { html += row(entry[0] + ':', escapeHtml(entry[1])); });
        html += row('Minimale afname:', escapeHtml(config.minimumQuantity + ' stuks'));
        html += '</div>';
      } else {
        html += row('Bedrukking:', escapeHtml(cleanPrintLabel(item?.print) || 'Onbedrukt'));
      }
      // Toon "Maat" alleen als er echt een maat-label is.
      if (sizeLabels.length === 1) {
        html += row('Maat:', escapeHtml(sizeLabels[0]));
      } else if (sizeLabels.length > 1) {
        html += row('Maten:', formatSizesDisplayHtml(sizesLines));
      }
      if (ppiLines.length) html += row('Prijs per stuk:', formatPpiDisplayHtml(ppiLines));
      if (totalExTxt) html += row('Totaal excl. btw:', escapeHtml(totalExTxt));
      if (totalIncTxt) html += row('Totaal incl. btw:', escapeHtml(totalIncTxt));
      return html;
    }

    if (o.onlyTop) return topRows();
    if (o.onlyDetails) return detailRows();
    return topRows() + detailRows();
  }

  function itemActionsHtml(item, opts) {
    var o = opts || {};
    if (o.readOnly) return '';
    var handle = item?.handle || '';
    var editUrl = handle ? '/products/' + handle + '?ss_offer_edit=' + encodeURIComponent(item.id) : (item?.url || '#');
    if (window.SSOffer?.getConfigurator?.(item) && handle) editUrl += '&view=19MW1016_configurator';

    return (
      '<div class="ss-offerte-item__actions">' +
      '<a class="ss-cart-action ss-cart-action--edit" data-ss-offerte-edit="' +
      escapeHtml(item.id) +
      '" href="' +
      escapeHtml(editUrl) +
      '">' +
      '<i class="ss-icon-chevron-down ss-cart-action__icon ss-cart-action__icon--chevron" aria-hidden="true"></i>' +
      'Aanpassen' +
      '</a>' +
      '<button type="button" class="ss-cart-action ss-cart-action--remove" data-ss-offerte-remove="' +
      escapeHtml(item.id) +
      '">' +
      '<div class="ss-icon-trash ss-cart-action__icon" aria-hidden="true"></div>' +
      'Verwijderen' +
      '</button>' +
      '</div>'
    );
  }

  function itemMediaHtml(item) {
    var img = item?.image || '';
    if (!img) return '';
    var title = item?.title || '';

    return (
      '<div class="ss-offerte-item__media">' +
      '<a href="' +
      escapeHtml(img) +
      '" data-fancybox="offer-media" data-caption="' +
      escapeHtml(title) +
      '">' +
      '<img src="' +
      escapeHtml(img) +
      '" alt="' +
      escapeHtml(title) +
      '" loading="lazy">' +
      '</a>' +
      '</div>'
    );
  }

  function renderList(items, options) {
    var opts = options || {};
    var list = qs('[data-ss-offerte-items]');
    var empty = qs('[data-ss-offerte-empty]');
    if (!list) return;

    if (!items || !items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var mode = isMobile ? 'accordion' : items.length <= 2 ? 'detail' : 'accordion';

    list.classList.toggle('ss-offerte-list--accordion', mode === 'accordion');

    var openId = null;
    if (mode === 'accordion') {
      // Op mobiel standaard alles dicht, maar na "Opslaan" willen we het item open laten.
      if (opts.openId) openId = opts.openId;
      else if (!isMobile) openId = items[0]?.id || null;
    }

    list.innerHTML = items
      .map(function (it, idx) {
        var isOpen = mode === 'detail' ? true : openId === it.id;

        if (mode === 'detail') {
          return (
            '<div class="ss-offerte-item" data-offer-id="' +
            escapeHtml(it.id) +
            '">' +
            itemMediaHtml(it) +
            '<div class="ss-offerte-item__body">' +
            '<div class="ss-offerte-item__rows">' +
            buildItemRowsHtml(it) +
            '</div>' +
            itemActionsHtml(it, { readOnly: opts.readOnly }) +
            '</div>' +
            '</div>'
          );
        }

        // accordion
        if (isMobile) {
          // Mobiel: foto boven, en chevron naast "Klik hier voor meer info" (geen linker chevron)
          return (
            '<div class="ss-offerte-item' +
            (isOpen ? ' is-open' : '') +
            '" data-offer-id="' +
            escapeHtml(it.id) +
            '">' +
            itemMediaHtml(it) +
            '<div class="ss-offerte-item__body">' +
            '<div class="ss-offerte-item__rows">' +
            buildItemRowsHtml(it, { onlyTop: true }) +
            '<div class="ss-offerte-hint-row">' +
            '<button type="button" class="ss-offerte-toggle ss-offerte-toggle--inline" aria-expanded="' +
            (isOpen ? 'true' : 'false') +
            '" data-ss-offerte-toggle="' +
            escapeHtml(it.id) +
            '"><i class="ss-icon ss-icon-chevron-down"></i></button>' +
            '<div class="ss-offerte-hint" role="button" tabindex="0" ' +
            (isOpen ? 'hidden' : '') +
            '>Klik hier voor meer info</div>' +
            '</div>' +
            '<div class="ss-offerte-details" ' +
            (isOpen ? '' : 'hidden') +
            '>' +
            buildItemRowsHtml(it, { onlyDetails: true }) +
            '</div>' +
            '</div>' +
            itemActionsHtml(it, { readOnly: opts.readOnly }) +
            '</div>' +
            '</div>'
          );
        }

        return (
          '<div class="ss-offerte-item' +
          (isOpen ? ' is-open' : '') +
          '" data-offer-id="' +
          escapeHtml(it.id) +
          '">' +
          '<button type="button" class="ss-offerte-toggle" aria-expanded="' +
          (isOpen ? 'true' : 'false') +
          '" data-ss-offerte-toggle="' +
          escapeHtml(it.id) +
          '"><i class="ss-icon ss-icon-chevron-down"></i></button>' +
          itemMediaHtml(it) +
          '<div class="ss-offerte-item__body">' +
          '<div class="ss-offerte-item__rows">' +
          buildItemRowsHtml(it, { onlyTop: true }) +
          '<div class="ss-offerte-hint" role="button" tabindex="0" ' +
          (isOpen ? 'hidden' : '') +
          '>Klik hier voor meer info</div>' +
          '<div class="ss-offerte-details" ' +
          (isOpen ? '' : 'hidden') +
          '>' +
          buildItemRowsHtml(it, { onlyDetails: true }) +
          '</div>' +
          '</div>' +
          itemActionsHtml(it, { readOnly: opts.readOnly }) +
          '</div>' +
          '</div>'
        );
      })
      .join('');
    window.SSOffer?.decorateConfiguratorColors?.(list);

    // Fancybox
    try {
      if (window.Fancybox && typeof window.Fancybox.bind === 'function') {
        window.Fancybox.bind('[data-fancybox="offer-media"]', {});
      }
    } catch (e) {}

    // flash na "Opslaan" (Aanpassen) — kort blauw → wit
    try {
      var flashId = opts && opts.openId ? String(opts.openId) : '';
      if (flashId) {
        var flashEl = qs('[data-offer-id="' + CSS.escape(flashId) + '"]', list);
        if (flashEl) {
          flashEl.classList.remove('ss-offerte-item--flash');
          void flashEl.offsetWidth; // reflow zodat hij opnieuw kan animeren
          flashEl.classList.add('ss-offerte-item--flash');
          flashEl.addEventListener(
            'animationend',
            function () {
              flashEl.classList.remove('ss-offerte-item--flash');
            },
            { once: true }
          );
        }
      }
    } catch (e1) {}

    // highlight laatst toegevoegde
    try {
      var lastId = sessionStorage.getItem('ss_offer_last_id');
      if (lastId) {
        var el = qs('[data-offer-id="' + CSS.escape(lastId) + '"]', list);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        sessionStorage.removeItem('ss_offer_last_id');
      }
    } catch (e2) {}
  }

  function computeTotals(items) {
    var ex = 0;
    var inc = 0;
    (items || []).forEach(function (it) {
      var t = getItemTotals(it);
      ex += t.exCents;
      inc += t.incCents;
    });
    if (!inc && ex) inc = Math.round(ex * 1.21);
    return { exCents: ex, incCents: inc, vatCents: Math.max(0, inc - ex) };
  }

  function renderOverview(items) {
    var t = computeTotals(items);
    var elEx = qs('[data-ss-offerte-subtotal-ex]');
    var elVat = qs('[data-ss-offerte-vat]');
    var elInc = qs('[data-ss-offerte-total-inc]');

    if (elEx) elEx.textContent = formatEUR(t.exCents);
    if (elVat) elVat.textContent = formatEUR(t.vatCents);
    if (elInc) elInc.textContent = formatEUR(t.incCents);
  }

  function collectUploads(items) {
    var rawSet = new Set();
    var lblSet = new Set();
    (items || []).forEach(function (it) {
      if (it && it.uploadsRaw) {
        String(it.uploadsRaw)
          .split(',')
          .map(function (x) {
            return x.trim();
          })
          .filter(Boolean)
          .forEach(function (x) {
            rawSet.add(x);
          });
      }
      if (it && it.uploadsLabel) {
        String(it.uploadsLabel)
          .split(',')
          .map(function (x) {
            return x.trim();
          })
          .filter(Boolean)
          .forEach(function (x) {
            lblSet.add(x);
          });
      }
    });
    return {
      uploadsRaw: Array.from(rawSet).join(','),
      uploadsLabel: Array.from(lblSet).join(', '),
    };
  }

  function buildHiddenFields(items) {
    var holder = qs('[data-ss-offerte-hidden]');
    if (!holder) return;
    holder.innerHTML = '';

    var totals = computeTotals(items);
    var uploads = collectUploads(items);

    function addHidden(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value || '');
      holder.appendChild(input);
    }

    // totals
    addHidden('contact[Subtotaal excl. btw]', formatEUR(totals.exCents));
    addHidden('contact[BTW]', formatEUR(totals.vatCents));
    addHidden('contact[Totaal incl. btw]', formatEUR(totals.incCents));

    // uploads
    if (uploads.uploadsLabel) addHidden('contact[Bestanden]', uploads.uploadsLabel);
    if (uploads.uploadsRaw) addHidden('contact[Upload IDs]', uploads.uploadsRaw);

    // items
    (items || []).forEach(function (it, idx) {
      var n = idx + 1;
      var sizesLines = sizesToLines(it);
      var parsedSizes = parseSizesFromItem(it);
      var sizeLabels = (parsedSizes || [])
        .map(function (s) {
          return String((s && s.label) || '').trim();
        })
        .filter(Boolean);
      var ppiLines = ppiToLines(it);
      var sku = stripSku(it?.sku || '');

      var parts = [];
      parts.push('Product: ' + (it?.title || ''));
      var colorLabel = guessColorLabel(it?.color, it?.title);
      if (colorLabel) parts.push('Kleur: ' + colorLabel);
      if (sku) parts.push('Artikelnummer: ' + sku);
      if (it?.qty != null) parts.push('Aantal: ' + it.qty + ' stuks');
      var configuration = window.SSOffer?.configuratorProperties?.(it);
      if (configuration) {
        Object.entries(configuration).forEach(function (entry) { parts.push(entry[0] + ': ' + entry[1]); });
      } else {
        parts.push('Bedrukking: ' + (cleanPrintLabel(it?.print) || 'Onbedrukt'));
      }
      if (sizeLabels.length === 1) {
        parts.push('Maat: ' + sizeLabels[0]);
      } else if (sizeLabels.length > 1) {
        parts.push('Maten:');
        sizesLines.forEach(function (l) {
          parts.push('- ' + cleanLine(l));
        });
      }
      if (ppiLines.length) {
        parts.push('Prijs per stuk:');
        ppiLines.forEach(function (l) {
          parts.push('- ' + cleanLine(l));
        });
      }
      if (it?.totalEx) parts.push('Totaal excl. btw: ' + it.totalEx);
      if (it?.totalInc) parts.push('Totaal incl. btw: ' + it.totalInc);
      if (it?.url) parts.push('URL: ' + it.url);

      addHidden('contact[Product ' + n + ']', parts.join('\n'));
    });
  }

  // ------------------------------------------------------------
  // Offerte "Aanpassen" modal (cart-style) — optie A
  // ------------------------------------------------------------

  var SS_OFFERTE_EDIT_SECTION_ID = 'ss-offerte-edit-data';
  var __ssOfferEditCache = Object.create(null);

  function safeParseJSON(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  function fetchOfferEditData(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.reject(new Error('Missing handle'));
    if (__ssOfferEditCache[handle]) return __ssOfferEditCache[handle];

    __ssOfferEditCache[handle] = Promise.all([
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + SS_OFFERTE_EDIT_SECTION_ID, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Section fetch failed');
          return r.text();
        }),
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Product JSON fetch failed');
          return r.json();
        }),
    ])
      .then(function (res) {
        var html = res[0];
        var product = res[1];

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var colors = safeParseJSON(qs('script[data-ss-offerte-edit-colors]', doc)?.textContent || '[]', []);
        var techniques = safeParseJSON(qs('script[data-ss-offerte-edit-techniques]', doc)?.textContent || '[]', []);
        var meta = safeParseJSON(qs('script[data-ss-offerte-edit-meta]', doc)?.textContent || '{}', {});
        var tierCfg = safeParseJSON(qs('#ss-b2b-tiers', doc)?.textContent || '{}', {});

        if (!Array.isArray(colors)) colors = [];
        if (!Array.isArray(techniques)) techniques = [];
        if (!meta || typeof meta !== 'object') meta = {};
        if (!tierCfg || typeof tierCfg !== 'object') tierCfg = {};

        return {
          handle: handle,
          product: product,
          colors: colors,
          techniques: techniques,
          meta: meta,
          tierCfg: tierCfg,
        };
      })
      .catch(function (err) {
        delete __ssOfferEditCache[handle];
        throw err;
      });

    return __ssOfferEditCache[handle];
  }

  function createOfferEditModal(renderAll) {
    var modal = byId('ssEditModal');
    if (!modal) {
      return {
        open: function () {},
        close: function () {},
      };
    }

    var titleEl = byId('ssEditModalTitle');
    var errorEl = byId('ssEditError');
    var qtyInput = byId('ssEditQty');
    var minHintEl = byId('ssEditMinHint');
    var colorWrap = byId('ssEditColorWrap');
    var colorSelect = byId('ssEditColor');
    var variantWrap = byId('ssEditVariantWrap');
    var variantSelect = byId('ssEditVariant');
    var techWrap = byId('ssEditTechniqueWrap');
    var techSelect = byId('ssEditTechnique');
    var sizesWrap = byId('ssEditSizesWrap');

    if (!sizesWrap && qtyInput) {
      var qtyRow = qtyInput.closest('.ss-modal__row');
      if (qtyRow) {
        sizesWrap = document.createElement('div');
        sizesWrap.id = 'ssEditSizesWrap';
        sizesWrap.className = 'ss-modal__sizes';
        qtyRow.appendChild(sizesWrap);
      }
    }
    var saveBtn = byId('ssEditSave');
    var cancelBtn = byId('ssEditCancel');

    var state = {
      offerId: null,
      item: null,
      handle: null,
      data: null,
      sizes: [],
    };

    function setOpen(isOpen) {
      modal.hidden = !isOpen;
      document.documentElement.classList.toggle('ss-modal-open', isOpen);
      if (!isOpen) {
        state.offerId = null;
        state.item = null;
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      var text = String(msg || '').trim();
      if (!text) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = text;
    }

    function showFixedError(fixed) {
      if (!errorEl) return;

      var allowed = Array.isArray(fixed)
        ? fixed
            .map(function (n) { return Number(n); })
            .filter(function (n) { return Number.isFinite(n) && n > 0; })
        : [];

      if (!allowed.length) {
        showError('Kies een geldig aantal.');
        return;
      }

      errorEl.hidden = false;
      errorEl.textContent = '';

      var labelSpan = document.createElement('span');
      labelSpan.textContent = 'Kies een geldig aantal: ';
      errorEl.appendChild(labelSpan);

      var wrap = document.createElement('span');
      wrap.className = 'ss-modal__qty-links';

      allowed.forEach(function (n, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss-modal__qty-link';
        btn.setAttribute('data-ss-set-qty', String(n));
        btn.textContent = String(n);
        wrap.appendChild(btn);
        if (idx < allowed.length - 1) {
          wrap.appendChild(document.createTextNode(', '));
        }
      });

      errorEl.appendChild(wrap);
    }

    function setLoading(isLoading) {
      [saveBtn, cancelBtn, qtyInput, colorSelect, variantSelect, techSelect].forEach(function (el) {
        if (!el) return;
        el.disabled = !!isLoading;
      });
    }

    function setWrapHidden(wrap, hidden) {
      if (!wrap) return;
      wrap.hidden = !!hidden;
    }

    function buildSelect(select, options, selectedValue) {
      if (!select) return;
      select.innerHTML = '';
      (options || []).forEach(function (opt) {
        var o = document.createElement('option');
        o.value = String(opt.value);
        o.textContent = String(opt.label);
        select.appendChild(o);
      });
      if (selectedValue != null) select.value = String(selectedValue);
    }

    function isActionPrintLockedMode(mode) {
      var m = String(mode || '').trim().toLowerCase();
      return m.indexOf('alleen bestelbaar met vaste opdruk') !== -1 ||
        m.indexOf('vaste opdruk + eigen rugbedrukking') !== -1;
    }

    function getVariantLabel(product, variantId) {
      variantId = String(variantId || '');
      var variants = Array.isArray(product?.variants) ? product.variants : [];
      var v = variants.find(function (x) { return String(x.id) === variantId; }) || variants[0];
      var title = v ? String(v.title || '').trim() : '';
      if (title === 'Default Title') return '';
      return title;
    }

    function getVariantIdForLabel(product, label) {
      label = String(label || '').trim();
      var variants = Array.isArray(product?.variants) ? product.variants : [];
      if (!variants.length) return '';
      if (!label) return String(variants[0].id);
      var v = variants.find(function (x) { return String(x.title || '').trim() === label; });
      if (v) return String(v.id);
      v = variants.find(function (x) {
        return Array.isArray(x.options) && String(x.options[0] || '').trim() === label;
      });
      return String((v || variants[0]).id);
    }

    function renderMinAndFixedHint(meta) {
      if (!minHintEl) return;

      var minQty = Number(meta && meta.min ? meta.min : 0);
      var fixed = parseQtyOptions(meta && meta.qtyOptions != null ? meta.qtyOptions : []);
      var strict = !!(meta && meta.qtyOptionsStrict);

      var hasMin = minQty > 0;
      // “Mogelijke aantallen” alleen tonen bij vaste staffel (qtyOptionsStrict = true)
      var hasFixed = strict && fixed.length > 0;

      if (!hasMin && !hasFixed) {
        minHintEl.hidden = true;
        minHintEl.textContent = '';
        return;
      }

      var frag = document.createDocumentFragment();

      if (hasMin) {
        frag.appendChild(
          document.createTextNode('Minimale afname: ' + minQty + ' stuks')
        );
      }

      if (hasFixed) {
        if (hasMin) frag.appendChild(document.createElement('br'));
        frag.appendChild(document.createTextNode('Mogelijke aantallen: '));

        var wrap = document.createElement('span');
        wrap.className = 'ss-modal__qty-links';

        fixed.forEach(function (n, idx) {
          var v = Number(n);
          if (!Number.isFinite(v) || v <= 0) return;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ss-modal__qty-link';
          btn.setAttribute('data-ss-set-qty', String(v));
          btn.textContent = String(v);
          wrap.appendChild(btn);
          if (idx < fixed.length - 1) {
            wrap.appendChild(document.createTextNode(', '));
          }
        });

        frag.appendChild(wrap);
      }

      minHintEl.textContent = '';
      minHintEl.appendChild(frag);
      minHintEl.hidden = false;
    }

    function renderSizesUi() {
      if (!sizesWrap || !qtyInput) return;
      // Extra maat-regels UI niet meer gebruiken: we houden de modal simpel
      // (alleen het hoofdveld "Aantal").
      sizesWrap.innerHTML = '';
      sizesWrap.hidden = true;
      qtyInput.readOnly = false;
    }

    function updateQtyFromVariant() {
      if (!qtyInput) return;

      // Alleen relevant wanneer 1 offertemandje-item meerdere maten bevat (oude bundel-logica).
      // In de huidige opzet is 1 item = 1 maat, dus we willen de hoeveelheid niet naar 0 resetten
      // wanneer de gebruiker een andere maat kiest.
      if (!Array.isArray(state.sizes) || state.sizes.length <= 1) return;

      var label = '';
      if (variantSelect && variantWrap && !variantWrap.hidden) {
        label = getVariantLabel(state.data?.product, variantSelect.value);
      }

      var found = (state.sizes || []).find(function (s) {
        return String(s.label || '').trim() === String(label || '').trim();
      });

      // Alleen overschrijven als we een match hebben (anders huidige qty laten staan)
      if (found) {
        qtyInput.value = String(Number(found.qty || 0));
      }
    }

    function renderModalFields() {
      var data = state.data;
      if (!data) return;

      var product = data.product || {};
      var colors = Array.isArray(data.colors) ? data.colors : [];
      var techniques = Array.isArray(data.techniques) ? data.techniques : [];
      var meta = data.meta || {};
      var printLocked = isActionPrintLockedMode(meta.bedrukkingModus || state.item?.bedrukkingModus || '');
      state.printLocked = printLocked;

      if (titleEl) {
        titleEl.textContent = 'Aanpassen' + (state.item?.title ? ': ' + state.item.title : '');
      }

      renderMinAndFixedHint(meta);

      // Kleuren
      var showColors = colors.length > 1;
      setWrapHidden(colorWrap, !showColors);
      if (showColors && colorSelect) {
        buildSelect(
          colorSelect,
          colors.map(function (c) {
            return { value: c.handle, label: c.label || c.title || c.handle };
          }),
          state.handle
        );
      }

      // Varianten (maten)
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var showVariants = variants.length > 1 && variants.some(function (v) { return String(v.title || '') !== 'Default Title'; });
      setWrapHidden(variantWrap, !showVariants);
      if (showVariants && variantSelect) {
        buildSelect(
          variantSelect,
          variants.map(function (v) {
            return { value: v.id, label: v.title };
          }),
          getVariantIdForLabel(product, (state.sizes[0] && state.sizes[0].label) || '')
        );
      }

      // Technieken
      var showTechniques = techniques.length > 0 && !printLocked;
      setWrapHidden(techWrap, !showTechniques);
      if (showTechniques && techSelect) {
        var opts = [{ value: '', label: 'Onbedrukt' }].concat(
          techniques.map(function (t) {
            return { value: t.id, label: t.title };
          })
        );
        var currentTechId = String(state.item?.techniqueId || '').trim();
        var hasCurrentTechId = currentTechId && opts.some(function (opt) {
          return String(opt.value) === currentTechId;
        });
        if (!hasCurrentTechId) {
          currentTechId = getTechniqueIdForLabel(state.item?.print || '', techniques);
        }
        buildSelect(techSelect, opts, currentTechId);
      }

      // Default qty (1 item = 1 maat)
      if (qtyInput) {
        var currentQty = 0;
        if (Array.isArray(state.sizes) && state.sizes[0] && Number(state.sizes[0].qty || 0) > 0) {
          currentQty = Number(state.sizes[0].qty || 0);
        } else if (state.item && Number(state.item.qty || 0) > 0) {
          currentQty = Number(state.item.qty || 0);
        }
        qtyInput.value = String(Math.max(0, Math.round(currentQty)));
      }

      renderSizesUi();
      updateQtyFromVariant();
    }

    function close() {
      showError('');
      setOpen(false);
    }

    function open(offerId) {
      offerId = String(offerId || '').trim();
      if (!offerId) return;
      if (!window.SSOffer || typeof window.SSOffer.get !== 'function') return;

      var item = window.SSOffer.get(offerId);
      if (!item) return;

      state.offerId = offerId;
      state.item = item;
      state.sizes = sizesArrayFromItem(item);
      if (!state.sizes.length && item.qty) {
        state.sizes = [{ label: '', qty: Number(item.qty || 0) }];
      }

      var handle = String(item.handle || '').trim();
      if (!handle && item.url) {
        var m = String(item.url).match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }
      if (!handle) {
        showError('Kan product niet aanpassen (geen handle gevonden).');
        setOpen(true);
        return;
      }

      // De eigen configurator bewaart kleuren, afwerking en transport samen.
      // Laat deze uitvoering op de PDP herberekenen in plaats van in de generieke modal.
      if (window.SSOffer?.getConfigurator?.(item)) {
        window.location.assign('/products/' + encodeURIComponent(handle) + '?view=19MW1016_configurator&ss_offer_edit=' + encodeURIComponent(offerId));
        return;
      }

      state.handle = handle;
      state.data = null;
      showError('');
      setLoading(true);

      fetchOfferEditData(handle)
        .then(function (data) {
          state.data = data;
          state.handle = data.handle;
          renderModalFields();
          setOpen(true);
        })
        .catch(function (err) {
          console.error(err);
          showError('Kan productdata niet ophalen. Probeer het opnieuw.');
          setOpen(true);
        })
        .finally(function () {
          setLoading(false);
        });
    }

    function save() {
      if (!state.offerId || !state.item || !state.data) return;
      if (!window.SSOffer || typeof window.SSOffer.upsert !== 'function') return;

      var item = state.item;
      var data = state.data;
      var product = data.product || {};
      var tierCfg = data.tierCfg || {};
      var meta = data.meta || {};

      var showVariants = variantWrap && !variantWrap.hidden;
      var showTechniques = techWrap && !techWrap.hidden && !state.printLocked;
      var showColors = colorWrap && !colorWrap.hidden;

      var selectedVariantId = showVariants && variantSelect ? String(variantSelect.value || '') : '';
      var label = showVariants ? getVariantLabel(product, selectedVariantId) : '';
      label = String(label || '').trim();
      if (label === 'Default Title') label = '';

      var qtyTotal = Math.max(0, int(qtyInput ? qtyInput.value : 0));
      var sizeLabel = '';
      if (showVariants && label) {
        sizeLabel = label;
      } else if (Array.isArray(state.sizes) && state.sizes[0] && state.sizes[0].label) {
        sizeLabel = String(state.sizes[0].label || '').trim();
      }
      var sizes = qtyTotal > 0 ? [{ label: sizeLabel, qty: qtyTotal }] : [];
      var minQty = Number(meta.min || 0);
      if (minQty > 0 && qtyTotal > 0) {
        var combinedQty = qtyTotal;
        try {
          if (window.SSOffer && typeof window.SSOffer.load === 'function') {
            var allItems = window.SSOffer.load() || [];
            var selfId = String(state.offerId || '');
            var currentKey = offerMinKey({
              minFamilyKey: meta.minFamilyKey != null ? meta.minFamilyKey : (item.minFamilyKey != null ? item.minFamilyKey : undefined),
              pid: (data.product && data.product.id) || item.pid,
              productId: item.productId,
              handle: state.handle || item.handle,
              id: state.offerId,
            });
            allItems.forEach(function (other) {
              if (!other) return;
              if (selfId && String(other.id || '') === selfId) return;
              if (offerMinKey(other) === currentKey) {
                combinedQty += Number(other.qty || 0);
              }
            });
          }
        } catch (e) {}

        if (combinedQty > 0 && combinedQty < minQty) {
          showError('Minimale afname is ' + minQty + ' stuks.');
          return;
        }
      }

      var fixed = parseQtyOptions(meta.qtyOptions);
      var strict = !!meta.qtyOptionsStrict;
      if (strict && fixed.length && qtyTotal > 0 && fixed.indexOf(qtyTotal) === -1) {
        showFixedError(fixed);
        return;
      }

      setLoading(true);
      showError('');

      try {
        if (qtyTotal <= 0) {
          window.SSOffer.remove(state.offerId);
        } else {
          var techId = showTechniques && techSelect ? String(techSelect.value || '') : '';
          var techLabel = showTechniques && techSelect
            ? String((techSelect.options[techSelect.selectedIndex] || {}).text || 'Onbedrukt')
            : String(item.print || 'Onbedrukt');
          if (!techId) techLabel = 'Onbedrukt';

          var next = Object.assign({}, item, {
            pid: String(product.id || item.pid || ''),
            productId: String(product.id || item.pid || ''),
            handle: state.handle,
            title: product.title || item.title,
            url: product.url || ('/products/' + state.handle),
            image: product.featured_image || item.image,
            qty: qtyTotal,
            sizes: sizes,
            sizesHTML: sizesArrayToHTML(sizes),
            variantId: selectedVariantId || '',
            variantTitle: label || '',
            print: techLabel,
            techniqueId: techId || '',
          });

          if (meta && meta.minFamilyKey != null && meta.minFamilyKey !== '') {
            next.minFamilyKey = meta.minFamilyKey;
          } else if (item.minFamilyKey != null && item.minFamilyKey !== '') {
            next.minFamilyKey = item.minFamilyKey;
          }

          // Kleur label (toon als "Royal Blue" i.p.v. de volledige titel)
          {
            var colors = Array.isArray(data.colors) ? data.colors : [];
            var c = colors.find(function (x) { return String(x.handle) === String(state.handle); });
            if (c) {
              var lbl = String(c.label || c.title || '').trim();
              if (lbl) next.color = lbl;
            }
          }

// SKU: pak van gekozen variant (of eerste)
          var vSku = '';
          if (Array.isArray(product.variants) && product.variants.length) {
            var vMatch = null;
            if (showVariants && selectedVariantId) {
              vMatch = product.variants.find(function (v) { return String(v.id) === String(selectedVariantId); });
            }
            vMatch = vMatch || product.variants[0];
            vSku = vMatch && vMatch.sku ? vMatch.sku : '';
            // A colour can be a separate Shopify product. Keep both legacy
            // and current identity fields aligned with its selected variant.
            next.vid = String(vMatch.id);
            next.variantId = String(vMatch.id);
          }
          if (vSku) next.sku = stripSku(vSku);

          var famKeyForGroup =
            meta.minFamilyKey != null && meta.minFamilyKey !== ''
              ? String(meta.minFamilyKey)
              : (item.minFamilyKey != null && String(item.minFamilyKey).trim() !== ''
                  ? String(item.minFamilyKey).trim()
                  : undefined);

          repriceOfferGroup(next, {
            product: product,
            tierCfg: tierCfg,
            techId: techId,
            techLabel: techLabel,
            techniques: Array.isArray(data.techniques) ? data.techniques : [],
            minFamilyKey: famKeyForGroup,
          });
        }

        if (typeof renderAll === 'function') renderAll({ openId: state.offerId });
        close();
      } catch (err) {
        console.error(err);
        showError('Opslaan is mislukt. Probeer het opnieuw.');
      } finally {
        setLoading(false);
      }
    }

    // Klikbare aantallen in hint en foutmelding
    if (minHintEl) {
      minHintEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ss-set-qty]');
        if (!btn || !qtyInput) return;
        var v = Number(btn.getAttribute('data-ss-set-qty') || '0');
        if (!v || !Number.isFinite(v)) return;
        // Update alle sizes evenredig? Voor nu: zet totale qty op 1 regel zonder maat.
        state.sizes = [{ label: '', qty: v }];
        qtyInput.value = String(v);
        showError('');
        renderSizesUi();
      });
    }

    if (errorEl) {
      errorEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ss-set-qty]');
        if (!btn || !qtyInput) return;
        var v = Number(btn.getAttribute('data-ss-set-qty') || '0');
        if (!v || !Number.isFinite(v)) return;
        state.sizes = [{ label: '', qty: v }];
        qtyInput.value = String(v);
        showError('');
        renderSizesUi();
      });
    }

    if (sizesWrap) {
      sizesWrap.addEventListener('input', function (e) {
        var inp = e.target.closest('input[data-ss-size-index]');
        if (!inp) return;
        var idx = Number(inp.getAttribute('data-ss-size-index') || '-1');
        if (!Number.isFinite(idx) || idx < 0) return;
        if (!Array.isArray(state.sizes) || idx >= state.sizes.length) return;
        var v = Number(inp.value || '0');
        if (!Number.isFinite(v) || v < 0) v = 0;
        state.sizes[idx].qty = v;
        if (qtyInput) qtyInput.value = String(sumSizesQty(state.sizes));
      });
    }

    // Events
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ss-modal-close]')) {
        e.preventDefault();
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }

      if (e.key === 'Enter' && saveBtn) {
        e.preventDefault();
        e.stopPropagation();
        saveBtn.click();
      }
    });
    if (colorSelect) colorSelect.addEventListener('change', function () {
      var newHandle = String(colorSelect.value || '').trim();
      if (!newHandle || newHandle === state.handle) return;

	      // Bewaar huidige selectie (voor als de nieuwe kleur dezelfde varianten/technieken heeft)
	      var prevVariantLabel = '';
	      if (variantSelect && variantWrap && !variantWrap.hidden && state.data?.product) {
	        prevVariantLabel = getVariantLabel(state.data.product, variantSelect.value);
	      }
	      var prevTechId = techSelect && techWrap && !techWrap.hidden ? String(techSelect.value || '') : '';
	      var prevTechLabel = '';
	      if (techSelect && techWrap && !techWrap.hidden) {
	        prevTechLabel = String((techSelect.options[techSelect.selectedIndex] || {}).text || '').trim();
	      }

      setLoading(true);
      showError('');
      fetchOfferEditData(newHandle)
        .then(function (data) {
          state.data = data;
          state.handle = data.handle;
          renderModalFields();

	          // restore techniek
	          if (techSelect && techWrap && !techWrap.hidden) {
	            var hasId = prevTechId && Array.prototype.some.call(techSelect.options, function (o) {
	              return String(o.value) === prevTechId;
	            });
	            if (hasId) {
	              techSelect.value = prevTechId;
	            } else if (prevTechLabel) {
	              Array.prototype.forEach.call(techSelect.options, function (o) {
	                if (String(o.text || '').trim() === prevTechLabel) techSelect.value = String(o.value);
	              });
	            }
	          }

	          // restore variant
	          if (variantSelect && variantWrap && !variantWrap.hidden && prevVariantLabel) {
	            variantSelect.value = getVariantIdForLabel(state.data?.product, prevVariantLabel);
	          }

	          updateQtyFromVariant();
        })
        .catch(function (err) {
          console.error(err);
          showError('Kan kleur/varianten niet laden.');
        })
        .finally(function () {
          setLoading(false);
        });
    });
    if (variantSelect) variantSelect.addEventListener('change', updateQtyFromVariant);
    if (saveBtn) saveBtn.addEventListener('click', function (e) {
      e.preventDefault();
      save();
    });

    return { open: open, close: close };
  }

  function bindAccordion(listEl, getItemsFn, openEditFn) {
    if (!listEl) return;

    listEl.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ss-offerte-toggle], .ss-offerte-hint');
      if (!trigger) return;

      var wrap = trigger.closest('[data-offer-id]');
      if (!wrap) return;

      var id = wrap.getAttribute('data-offer-id');
      if (!id) return;

      var btn = qs('[data-ss-offerte-toggle]', wrap);

      // enkel 1 open tegelijk
      qsa('.ss-offerte-item.is-open', listEl).forEach(function (el) {
        if (el === wrap) return;
        el.classList.remove('is-open');
        var d = qs('.ss-offerte-details', el);
        if (d) d.hidden = true;
        var h = qs('.ss-offerte-hint', el);
        if (h) h.hidden = false;
        var b = qs('[data-ss-offerte-toggle]', el);
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      var isOpen = wrap.classList.toggle('is-open');
      var details = qs('.ss-offerte-details', wrap);
      if (details) details.hidden = !isOpen;
      if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // hint togglen
      var hint = qs('.ss-offerte-hint', wrap);
      if (hint) hint.hidden = isOpen;
    });

    listEl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-ss-offerte-remove]');
      if (!rm) return;
      var id = rm.getAttribute('data-ss-offerte-remove');
      if (!id) return;

      e.preventDefault();

      if (!window.SSOffer || typeof window.SSOffer.load !== 'function' || typeof window.SSOffer.remove !== 'function') {
        return;
      }

      var items = window.SSOffer.load() || [];
      var item = items.find(function (it) { return it && String(it.id || '') === String(id); });
      if (!item) return;

      if (window.SSOffer?.getConfigurator?.(item)) {
        window.SSOffer.remove(id);
        return;
      }

      var handle = String(item.handle || '').trim();
      if (!handle && item.url) {
        var m = String(item.url).match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }

      if (!handle) {
        window.SSOffer.remove(id);
        var itemsAfter = window.SSOffer.load();
        renderList(itemsAfter);
        renderOverview(itemsAfter);
        buildHiddenFields(itemsAfter);
        return;
      }

      fetchOfferEditData(handle)
        .then(function (data) {
          var meta = data && data.meta ? data.meta : {};
          var minQty = Number(meta.min || 0);
          if (!minQty) {
            window.SSOffer.remove(id);
            var itemsAfter = window.SSOffer.load();
            renderList(itemsAfter);
            renderOverview(itemsAfter);
            buildHiddenFields(itemsAfter);
            return;
          }

          var selfKey = offerMinKey({
            minFamilyKey: meta.minFamilyKey != null ? meta.minFamilyKey : (item.minFamilyKey != null ? item.minFamilyKey : undefined),
            pid: item.pid || (data.product && data.product.id),
            productId: item.productId,
            handle: handle,
            id: id,
          });

          var combined = 0;
          (items || []).forEach(function (other) {
            if (!other) return;
            if (String(other.id || '') === String(id)) return;
            if (offerMinKey(other) === selfKey) {
              combined += Number(other.qty || 0);
            }
          });

          if (combined > 0 && combined < minQty) {
            showOfferteMinModal(
              minQty +
                ' stuks is de minimale afname. Pas de aantallen aan tot minimaal ' +
                minQty +
                ' stuks in totaal.'
            );
            return;
          }

          window.SSOffer.remove(id);
          var itemsAfter = window.SSOffer.load();
          renderList(itemsAfter);
          renderOverview(itemsAfter);
          buildHiddenFields(itemsAfter);
        })
        .catch(function () {
          window.SSOffer.remove(id);
          var itemsAfter = window.SSOffer.load();
          renderList(itemsAfter);
          renderOverview(itemsAfter);
          buildHiddenFields(itemsAfter);
        });
    });

    // Aanpassen
    listEl.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-ss-offerte-edit]');
      if (!a) return;

      // modifiers (nieuw tabblad, etc.) => laat browser het doen
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)
        return;

      if (typeof openEditFn !== 'function') return;

      e.preventDefault();
      openEditFn(a.getAttribute('data-ss-offerte-edit'));
    });
  }

  function bindForm(itemsProvider, onReceived) {
    var form = qs('#ssOfferteForm');
    if (!form || qs('[data-ss-offerte-success]', form)) return;
    var status = qs('[data-ss-offerte-status]', form);
    var button = qs('button[type="submit"]', form);
    var label = button.textContent, busy = false;
    var base = qs('[data-ss-offerte-summary]')?.getAttribute('data-receive-url');
    if (!base) return;
    function notice(message) { status.hidden = false; status.textContent = message; }
    function fields() {
      var data = {};
      ['company','name','email','phone','message','address1','zip','city','countryCode','vatNumber'].forEach(function(k){data[k]=qs('[data-ss-offerte-field="'+k+'"]', form)?.value || '';});
      if(data.countryCode==='NL')data.vatNumber='';
      return data;
    }
    function cache(key, data) {
      var raw = JSON.stringify(data);
      try {
        sessionStorage.setItem(key, raw);
        if (sessionStorage.getItem(key) !== raw) throw new Error();
      } catch(e) { throw new Error('Je browser kan deze verzendpoging niet bewaren. Sta websiteopslag toe en probeer opnieuw.'); }
    }
    try {
      var saved = JSON.parse(sessionStorage.getItem('ss_offer_form_v1') || '{}');
      Object.keys(saved).forEach(function(k){var input=qs('[data-ss-offerte-field="'+k+'"]',form);if(input)input.value=saved[k];});
    } catch(e) { notice('Je browser bewaart ingevulde gegevens mogelijk niet. Houd deze pagina open.'); }
    function renderCountry() {
      var country=qs('[data-ss-offerte-field="countryCode"]',form);
      if(!country)return;
      if(['NL','BE','DE'].indexOf(country.value)<0)country.value='NL';
      qsa('[data-ss-quote-country]',form).forEach(function(b){b.setAttribute('aria-pressed',String(b.getAttribute('data-ss-quote-country')===country.value));});
      var vat=qs('[data-ss-quote-vat]',form);if(vat)vat.hidden=country.value==='NL';
    }
    qsa('[data-ss-quote-country]',form).forEach(function(b){b.addEventListener('click',function(){
      qs('[data-ss-offerte-field="countryCode"]',form).value=b.getAttribute('data-ss-quote-country');renderCountry();
      try{cache('ss_offer_form_v1',fields());}catch(e){notice(e.message);}
    });});
    renderCountry();
    form.addEventListener('input',function(){try{cache('ss_offer_form_v1',fields());}catch(e){notice('Je browser bewaart de ingevulde gegevens niet. Sta websiteopslag toe voordat je verstuurt.');}});
    async function post(path,data) {
      var controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},90000);
      try {
        var response=await fetch(base+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data),signal:controller.signal});
        var result=await response.json().catch(function(){return null;});
        if(!response.ok||!result?.ok){var error=new Error(result?.message || 'De ontvangst is nog niet bevestigd. Je gegevens blijven bewaard. Probeer opnieuw.');error.definite=response.status>=400&&response.status<500&&response.status!==409;throw error;}
        return result;
      } finally {clearTimeout(timeout);}
    }
    button.disabled=false;
    form.addEventListener('submit',async function(event){
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!form.reportValidity())return;
      var items=itemsProvider();
      if(!items.length){notice('Voeg eerst een product toe aan je aanvraag.');return;}
      busy=true;button.disabled=true;button.textContent='Aanvraag versturen…';notice('Je aanvraag wordt verstuurd.');
      try {
        var pending;
        try {pending=JSON.parse(sessionStorage.getItem('ss_offer_pending_v2')||'null');}catch(e){}
        var payload={form:fields(),items:items,website:qs('[name="contact[bot-field]"]',form)?.value||''};
        var signature=JSON.stringify(payload);
        if(pending&&pending.signature!==signature){
          // An unanswered attempt may already exist. Resolve that exact attempt first.
          notice('We controleren eerst je vorige verzendpoging. Wijzigingen worden niet als een tweede aanvraag verstuurd.');
        } else if(!pending){
          pending={requestKey:crypto.randomUUID(),signature:signature,payload:payload,at:Date.now()};
          cache('ss_offer_pending_v2',pending);
        }
        var session=await post('/api/session',{});
        var result=await post('/api/submit',Object.assign({},pending.payload,{requestKey:pending.requestKey,challenge:session.challenge}));
        // Receipt persistence happens before clearing anything. If storage fails, retry
        // with the same request key safely; the server returns the existing quote.
        var snap={receipt:result,items:pending.payload.items,form:pending.payload.form,totals:computeTotals(pending.payload.items),at:pending.at};
        cache('ss_offer_received_v2',snap);
        sessionStorage.removeItem('ss_offer_pending_v2');
        sessionStorage.removeItem('ss_offer_form_v1');
        history.replaceState(null,'',location.pathname+'#aanvraag='+result.id);
        onReceived(snap,true);
      } catch(error) {
        if(error?.definite){try{sessionStorage.removeItem('ss_offer_pending_v2');}catch(e){}}
        var message=error?.name==='AbortError'?'De ontvangst is nog niet bevestigd. Je aanvraag blijft bewaard. Klik opnieuw op versturen om dezelfde aanvraag te controleren.':error?.message;
        notice(message||'Versturen is niet bevestigd. Probeer opnieuw; je gegevens blijven bewaard.');
      } finally {busy=false;button.disabled=false;button.textContent=label;}
    },true);
  }

  function runSuccessFlow(summaryEl) {
    // alleen op succes view
    if (!summaryEl) return;
    if (!qs('[data-ss-offerte-success]')) return;

    var raw = '';
    try {
      raw = sessionStorage.getItem('ss_offer_last_submitted_v1') || '';
    } catch (e) {}
    if (!raw) return;

    var snap = null;
    try {
      snap = JSON.parse(raw);
    } catch (e2) {}
    if (!snap || !snap.form || !snap.form.email) return;

    var email = String(snap.form.email || '').trim();
    if (!email) return;

    // dedupe
    var sig = email + '|' + (snap.at || '') + '|' + (snap.totals?.exCents || 0);
    try {
      var prev = sessionStorage.getItem('ss_offer_sig_v1');
      if (prev === sig) return;
      sessionStorage.setItem('ss_offer_sig_v1', sig);
    } catch (e3) {}

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quote_submitted',
    });

    var webhookUrl = summaryEl.getAttribute('data-webhook-url') || '';
    var confirmUrl = summaryEl.getAttribute('data-confirm-url') || '';

    var uploadsRaw = snap.uploads?.uploadsRaw || '';
    var uploadsLabel = snap.uploads?.uploadsLabel || '';

    // ---- Meta voor bevestigingsmail: backend verwacht vaste keys ----
    // (handle, product_title, color, sku, qty, print, sizesHTML, ppiHTML, totalEx, totalInc)
    var items = Array.isArray(snap.items) ? snap.items : [];
    var qtyTotal = items.reduce(function (sum, it) {
      return sum + (Number(it && it.qty) || 0);
    }, 0);

    var totalsExCents = snap.totals?.exCents || 0;
    var totalsVatCents = snap.totals?.vatCents || 0;
    var totalsIncCents = snap.totals?.incCents || 0;
    var totalsEx = formatEUR(totalsExCents);
    var totalsInc = formatEUR(totalsIncCents);

    function block(title, htmlLines) {
      var t = String(title || '').trim();
      var lines = splitBr(htmlLines || '').map(cleanLine).filter(Boolean);
      if (!t && !lines.length) return '';
      if (!lines.length) return t;
      return t ? (t + '<br>' + lines.join('<br>')) : lines.join('<br>');
    }

    var mailer = {};
    if (items.length === 1) {
      var it0 = items[0] || {};
      var tot0 = getItemTotals(it0);
      mailer = {
        handle: it0.handle || '',
        product_title: it0.title || '',
        color: guessColorLabel(it0.color, it0.title) || '',
        sku: stripSku(it0.sku || ''),
        qty: it0.qty || 0,
        print: it0.print || 'Onbedrukt',
        sizesHTML: it0.sizesHTML || '',
        ppiHTML: it0.ppiHTML || '',
        totalEx: it0.totalEx || formatEUR(tot0.exCents),
        totalInc: it0.totalInc || formatEUR(tot0.incCents),
      };
    } else {
      mailer = {
        handle: '',
        product_title: items.map(function (it, i) { return (i + 1) + '. ' + (it.title || ''); }).join('\n'),
        color: items.map(function (it, i) { return (i + 1) + '. ' + (guessColorLabel(it.color, it.title) || ''); }).join('\n'),
        sku: items.map(function (it, i) { return (i + 1) + '. ' + stripSku(it.sku || ''); }).join('\n'),
        qty: qtyTotal,
        print: items.map(function (it, i) { return (i + 1) + '. ' + (cleanPrintLabel(it.print) || 'Onbedrukt'); }).join('\n'),
        sizesHTML: items.map(function (it) { return block(it.title || '', it.sizesHTML || ''); }).filter(Boolean).join('<br><br>'),
        ppiHTML: items.map(function (it) { return block(it.title || '', it.ppiHTML || ''); }).filter(Boolean).join('<br><br>'),
        totalEx: totalsEx,
        totalInc: totalsInc,
      };
    }

    var meta = Object.assign({}, mailer, {
      title:
        items.length === 1
          ? (items[0].title || 'Offerte')
          : items.length
            ? items.length + ' producten'
            : 'Offerte',
      qty: String(qtyTotal),
      offer_url: snap.url,
      totals: {
        ex: totalsEx,
        vat: formatEUR(totalsVatCents),
        inc: totalsInc,
        exCents: totalsExCents,
        vatCents: totalsVatCents,
        incCents: totalsIncCents,
      },
      items: items.map(function (it) {
        return {
          title: it.title || '',
          color: guessColorLabel(it.color, it.title) || '',
          sku: stripSku(it.sku || ''),
          qty: it.qty || 0,
          print: cleanPrintLabel(it.print) || 'Onbedrukt',
          sizes: sizesToLines(it),
          ppi: ppiToLines(it),
          totalEx: it.totalEx || (Number.isFinite(it.totalExCents) ? formatEUR(it.totalExCents) : ''),
          totalInc: it.totalInc || (Number.isFinite(it.totalIncCents) ? formatEUR(it.totalIncCents) : ''),
          url: it.url || '',
          handle: it.handle || '',
          sizesHTML: it.sizesHTML || '',
          ppiHTML: it.ppiHTML || '',
          uploads_raw: it.uploadsRaw || '',
          uploads_label: it.uploadsLabel || '',
          configurator: window.SSOffer?.getConfigurator?.(it) || null,
          configurationProperties: window.SSOffer?.configuratorProperties?.(it) || null,
          image: it.image || '',
        };
      }),
      uploads_raw: uploadsRaw,
      uploads_label: uploadsLabel,
    });

    // webhook (uploads mark sent)
    if (webhookUrl && uploadsRaw) {
      fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ quote_id: null, email: email, uploads_raw: uploadsRaw, meta: meta }),
      })
        .then(function (res) {
          if (res && res.ok) return;
          return (res && res.text ? res.text() : Promise.resolve('')).then(function (t) {
            console.warn('[ss-offerte] webhook fout', res && res.status, t || '');
          });
        })
        .catch(function (err) {
          console.warn('[ss-offerte] webhook fout', err);
        });
    }

    // confirm mail
    if (confirmUrl) {
      fetch(confirmUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ email: email, meta: meta }),
      })
        .then(function (res) {
          if (res && res.ok) return;
          return (res && res.text ? res.text() : Promise.resolve('')).then(function (t) {
            console.warn('[ss-offerte] confirm fout', res && res.status, t || '');
          });
        })
        .catch(function (err) {
          console.warn('[ss-offerte] confirm fout', err);
        });
    }

    // opruimen (maar snapshot laten staan zodat succespagina niet leeg wordt)
    try {
      if (window.SSOffer && typeof window.SSOffer.clear === 'function') window.SSOffer.clear();
      sessionStorage.removeItem('ss_offer_form_v1');
    } catch (e4) {}
  }

  function applySuccessHeader(isSuccessPage, summaryEl) {
    if (!isSuccessPage) return;
    if (!summaryEl) return;

    var root = qs('[data-ss-offerte-root]');
    if (!root) return;

    var header = qs('.ss-offerte-header', root);
    if (!header) return;

    var successTitle = summaryEl.getAttribute('data-success-title') || '';
    var successMessage = summaryEl.getAttribute('data-success-message') || '';
    if (!successTitle && !successMessage) return;

    var defaultTitleEl = qs('[data-ss-offerte-title]', header);
    var defaultIntroEl = qs('[data-ss-offerte-intro]', header);
    var successHeaderEl = qs('[data-ss-offerte-success-header]', header);
    if (!successHeaderEl) return;

    var successHeaderTitleEl = qs('[data-ss-offerte-success-header-title]', header);
    var successHeaderTextEl = qs('[data-ss-offerte-success-header-text]', header);

    if (successHeaderTitleEl && successTitle) {
      successHeaderTitleEl.textContent = successTitle;
    }

    if (successHeaderTextEl) {
      successHeaderTextEl.innerHTML = successMessage || '';
    }

    if (defaultTitleEl) defaultTitleEl.hidden = true;
    if (defaultIntroEl) defaultIntroEl.hidden = true;

    successHeaderEl.hidden = false;
  }

  function main() {
    normalizeFromLegacySession();

    var isSuccessPage = !!qs('[data-ss-offerte-success]');
    var received = null;
    try {
      var candidate = JSON.parse(sessionStorage.getItem('ss_offer_received_v2') || 'null');
      if (candidate?.receipt?.id && location.hash === '#aanvraag=' + candidate.receipt.id) received = candidate;
    } catch (e) {}
    if (received) isSuccessPage = true;

    var items = [];

    if (received) items = received.items;
    // Legacy Shopify success stays available for previously opened forms.
    if (isSuccessPage && !received) {
      try {
        var rawSnap = sessionStorage.getItem('ss_offer_last_submitted_v1') || '';
        if (rawSnap) {
          var snap = JSON.parse(rawSnap);
          if (snap && Array.isArray(snap.items) && snap.items.length) items = snap.items;
        }
      } catch (e0) {}
    }

    if (!items.length && window.SSOffer && typeof window.SSOffer.load === 'function') {
      items = window.SSOffer.load();
    }

    // render
    renderList(items, { readOnly: isSuccessPage });
    renderOverview(items);
    buildHiddenFields(items);

    var listEl = qs('[data-ss-offerte-items]');

    function renderAll(opts) {
      var it = window.SSOffer && typeof window.SSOffer.load === 'function' ? window.SSOffer.load() : [];
      renderList(it, opts || {});
      renderOverview(it);
      buildHiddenFields(it);
    }

    var editModal = !isSuccessPage ? createOfferEditModal(renderAll) : null;

    bindAccordion(
      listEl,
      function () {
        return window.SSOffer && typeof window.SSOffer.load === 'function' ? window.SSOffer.load() : [];
      },
      !isSuccessPage && editModal ? editModal.open : null
    );

    function showReceived(snap, newlyReceived) {
      isSuccessPage = true;
      received = snap;
      if (newlyReceived) {
        // Remove only the exact submitted rows. Changes made in another tab survive.
        var sent = new Map(snap.items.map(function(item){return [item.id,JSON.stringify(item)];}));
        try { window.SSOffer.save(window.SSOffer.load().filter(function(item){return sent.get(item.id)!==JSON.stringify(item);})); } catch(e) {}
      }
      renderList(snap.items, {readOnly:true});renderOverview(snap.items);
      var form=qs('#ssOfferteForm');
      if(form){
        form.replaceChildren();
        var title=document.createElement('h2');title.textContent='Aanvraag ontvangen';
        var info=document.createElement('p');info.textContent='Je aanvraag is opgeslagen onder nummer '+snap.receipt.number+'. Je ontvangt een bevestiging per e-mail.';
        var link=document.createElement('a');link.href='/';link.className='btn accent';link.textContent='Verder winkelen';
        form.append(title,info,link);
      }
      applySuccessHeader(true,qs('[data-ss-offerte-summary]'));
      if(newlyReceived){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'quote_submitted'});}
    }
    if(received)showReceived(received,false);
    else bindForm(function () {
      return window.SSOffer && typeof window.SSOffer.load === 'function' ? window.SSOffer.load() : [];
    },showReceived);

    // A layout rendered on desktop must also adapt when a phone rotates or
    // the window crosses the mobile breakpoint. Keep the received snapshot;
    // its submitted rows have already been removed from the editable basket.
    if (window.matchMedia) {
      var mobileLayout = window.matchMedia('(max-width: 749px)');
      var updateListLayout = function () {
        var openItem = qs('.ss-offerte-item.is-open', listEl);
        var visibleItems = received ? received.items : isSuccessPage ? items :
          window.SSOffer && typeof window.SSOffer.load === 'function' ? window.SSOffer.load() : [];
        renderList(visibleItems, {
          readOnly: isSuccessPage,
          openId: openItem ? openItem.getAttribute('data-offer-id') : null
        });
      };
      if (mobileLayout.addEventListener) mobileLayout.addEventListener('change', updateListLayout);
      else if (mobileLayout.addListener) mobileLayout.addListener(updateListLayout);
    }

    // success flow + header
    var summaryEl = qs('[data-ss-offerte-summary]');
    applySuccessHeader(isSuccessPage, summaryEl);
    if (!received) runSuccessFlow(summaryEl);

    // update overview when offer changes (via remove, add in andere tab, etc.)
    if (!isSuccessPage) {
      document.addEventListener('ss:offer:changed', function () {
        if (!isSuccessPage) renderAll();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', main);
})();
